import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";

const FoQi = () => {

  let foqiDetail=<Stack direction="horizontal" gap={4}>
  <img src="/foqi-thumbnail.png" />
  <div>
    <Typography variant="body1">念佛名號（佛七）是一項為期一周的靜修活動，專注於念誦阿彌陀佛佛名號和淨土法。​<br/><br/>請 <a href="https://www.chanpureland.org/32852319952510520204.html" target="_blank">點擊此處</a> ，報名參加<br/></Typography>
  </div>
  </Stack>;

if((typeof window !== 'undefined') && window.screen.width< 667) {
  foqiDetail=<>
  <img src="/foqi-thumbnail.png" />
  <div>
    <Typography variant="body1">念佛名號（佛七）是一項為期一周的靜修活動，專注於念誦阿彌陀佛佛名號和淨土法。​<br/><br/>請 <a href="https://www.chanpureland.org/32852319952510520204.html" target="_blank">點擊此處</a> ，報名參加<br/></Typography>
  </div></>;

}

return (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    alt=""
    src="/foqiBanner.png" />
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
      <Typography variant="h3">
      <strong>念佛名號（佛七）</strong>
      </Typography><br/>
  {foqiDetail}
<a href="/foqi-schedule.png">
  <img src="/foqi-schedule.png" quality={40} />
</a>
  </Layout>
  </>
)}

export default FoQi
